import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=97ea27d0&scoped=true&"
import script from "./NotAllowed.vue?vue&type=script&lang=js&"
export * from "./NotAllowed.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=97ea27d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ea27d0",
  null
  
)

export default component.exports